import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useFormSchema = () => {
  const { t } = useTranslation('translation');

  const sendMessageSchema = z.object({
    message: z
      .string()
      .min(1, t('common.formErrors.required'))
      .max(5000, t('common.formErrors.stringMaxLen', { max: 5000 })),
  });

  return sendMessageSchema;
};
